import {ENDPOINT_CAMUNDA} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const restartExternalTasks = (body) => {
  return fetch(
    `${ENDPOINT_CAMUNDA}external-task/retries`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
      body: JSON.stringify(body),
    }
  );    
};

const restartActivity = (process, body) => {
  return fetch(
    `${ENDPOINT_CAMUNDA}process-definition/${process}/restart`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify(body),
    }
  );    
};

export default {
  restartExternalTasks,
  restartActivity,
};
